module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content"
  }, [_c('p', {
    staticClass: "text-center mb20"
  }, [_vm._v("Are you sure you want to " + _vm._s(_vm.archiveText) + " this project?")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex--justify-center"
  }, [_c('button', {
    staticClass: "btn btn--wide btn--gray-2 mr10",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$bus.$emit('modalClose')
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--wide",
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v("Yes")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d2971b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/projects/modals/ProjectArchiveModal.vue
// module id = 425
// module chunks = 2